import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: send/receive the httpOnly session cookie on every request.
export const api = axios.create({ baseURL: API, withCredentials: true });

// In-memory Bearer fallback for environments where 3rd-party cookies are blocked
// (e.g. cross-site iframes with strict browser cookie policies). NOT stored in
// localStorage — cleared on tab close, safe from XSS token theft.
let _bearer = null;

export function setBearer(token) {
  _bearer = token || null;
}

export function clearBearer() {
  _bearer = null;
}

api.interceptors.request.use((config) => {
  if (_bearer) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${_bearer}`;
  }
  return config;
});
